import React from 'react';
import Editor from './Editor';

export default function App() {
  return (
    <div className="min-h-screen px-4 py-8 sm:px-6 lg:px-10">
      <header className="mx-auto mb-6 max-w-6xl">
        <p className="text-xs uppercase tracking-[0.22em] text-slate-600">A Realtime Workspace</p>
        <h1 className="mt-1 text-3xl font-bold text-slate-900 sm:text-4xl">Collaborative Text Editor</h1>
        <p className="mt-2 max-w-2xl text-sm text-slate-700 sm:text-base">
          Shared editing with online presence, colored cursors, formatting tools, and revision restore.
        </p>
      </header>
      <Editor />
    </div>
  );
}
